import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../routes/routes';
import { installationExalusLocalState } from '../../../../utils/helpers/local-app';
import { getParameterByName } from '../../../../utils/location';

const ExalusQRCodeAuth: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const serialNumber = getParameterByName('serialNumber');
    const pin = getParameterByName('pin');

    navigate(
      ROUTES.ExalusIntegrationCreate({
        ...installationExalusLocalState,
        exalusCredentials: {
          serialNumber,
          pin,
        },
      }),
    );
  }, []);

  return null;
};

export default ExalusQRCodeAuth;
